import { useEffect, useState, lazy, Suspense } from "react";
import useSessionStore from "../Lib/Context";
import { GAMSetup } from "../Components/GAMSetup";
import Spinner from "../Components/Spinner";
import { PreChecks } from "../Lib/Prechecks";
import { InitializeAds } from "../Lib/gpt-ad-manager";
import ReactGA from "react-ga4";

// Lazy load AgeCap - only needed if age_cap_ad is set
const AgeCap = lazy(() => import("../Components/AgeCap").then(module => ({ default: module.AgeCap })));

function MiddleWare() {
  const { SessionData, setSessionData } = useSessionStore();
  const DoingPreCheck = PreChecks();
  const [ErrorState, setErrorState] = useState(false);
  const [isLoading, setisLoading] = useState(true);
  const [GA4Loaded, setGA4Loaded] = useState(false);
  const [LoadAgeCap, setLoadAgeCap] = useState(false);
  const GAMAPIReady = InitializeAds(SessionData);

  const isAuthenticatedToday = () => {
    return document.cookie
      .split(";")
      .some((c) => c.trim().startsWith("authenticated=true"));
  };

  function Initialize_GA4() {
    console.log(SessionData);
    if (SessionData.google_analytics_tag) {
      ReactGA.initialize([
        {
          trackingId: "G-H1XNVC8QDN",
        },
        {
          trackingId: SessionData.google_analytics_tag,
        },
      ]);
      console.log("added GA4 tag");
      console.log(SessionData.google_analytics_tag);
      setGA4Loaded(true);
    } else {
      ReactGA.initialize([
        {
          trackingId: "G-H1XNVC8QDN",
        },
      ]);
      console.log("No extra GA4 tag");
      setGA4Loaded(true);
    }
  }

  useEffect(() => {
    if (DoingPreCheck) {
      if (GAMAPIReady) {
        if (!GA4Loaded) {
          Initialize_GA4();
        } else {
          ReactGA.set({ user_properties: {
      place_name: SessionData.place_name,
      // user_tier: 'Premium' // You can add other properties here
    }});
          if (SessionData.targeting.age_cap_ad) {
            setLoadAgeCap(true);
          } else {
            //setLoadAgeCap(true)
            if (isAuthenticatedToday() && SessionData.firstPath === "fatti") {
              let AuthUrl = `https://${SessionData.secondPath}/portal/${SessionData.thirdPath}/${SessionData.savedRedirect}`;
              window.location.href = AuthUrl; // User already authenticated today, adjust UI/flow
            } else {
              setisLoading(false);
            }
          }
        }
      }
    }
  }, [DoingPreCheck, GA4Loaded, GAMAPIReady]);

  if (LoadAgeCap) {
    return (
      <Suspense fallback={<Spinner />}>
        <AgeCap />
      </Suspense>
    );
  }
  if (isLoading) {
    return <Spinner />;
  }

  if (ErrorState) {
    // Return error page instead of exposing SessionData
    return (
      <div>
        <h2>Something went wrong</h2>
        <p>Please refresh the page and try again.</p>
        {process.env.NODE_ENV === 'development' && (
          <details>
            <summary>Debug Info (Development Only)</summary>
            <pre>{JSON.stringify(SessionData, null, 2)}</pre>
          </details>
        )}
      </div>
    );
  } else {
    return (
      <div>
        {/* <LeadForm /> */}
        <GAMSetup />
      </div>
    );
  }
}

export default MiddleWare;
